import { Box, styled } from '@mui/material'

export const StyledBox = styled(Box)`
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  height: 72px;
`
